import styled from "styled-components";

export const Wrapper = styled.div`
  /* background-color: red; */
  height: 100%;
  /* color: #ffffff; */
  /* display: flex; */
  justify-content: center;
  align-items: center;
  /* font-size: 18px; */
  user-select: none;
  position: relative;
  user-select: none;
`;

export const PlayerWrapper = styled.div`
  width: 100%;
  /* display: flex; */
  /* align-items: center; */
  position: absolute;
  bottom: 0px;
  /* background-color: white; */
  /* background-color: white; */
`;

export const Timeline = styled.div`
  width: 100%;
  height: 5px;
  /* background-color: lightgrey; */
  position: relative;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: ${({ percentage }) => `${percentage}%`};
    background-color: ${({ name }) => `var(--border-${name})`};
  }
`;

export const PlayerBtnsWrapper = styled.div`
  /* width: 100%; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0px;
  background-color: white;
  /* border-radius: 50px; */
  padding: 0 10px 35px;

  /* border: 1px solid lightgrey; */
`;

export const MainBtnsWrapper = styled(PlayerBtnsWrapper)`
  margin: unset;
  justify-content: center;
  padding: unset;
  width: fit-content;
  /* border-bottom: 1px solid black; */
`;

export const ContBtn = styled.button`
  display: block;
  width: 60px;
  height: 60px;
  font-size: 32px;
  /* font-weight: bold; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border: 0;
  background-color: white;
  /* background-color: transparent; */
  border-radius: 50px;
  svg {
    width: 100%;
    height: 100%;
    transition-duration: 0.2s;
  }
  img {
    /* transition-duration: 0.5s; */
  }
`;

export const MainContBtn = styled(ContBtn)`
  scale: 1.25;
  translate: 0px -7px;
  border: 1px solid lightgrey;
  margin: 0% 12px;
  padding: 15px;
  background-color: ${({ name }) => `var(--border-${name})`};
`;

export const SpeedBtn = styled.div``;

export const ImgIcon = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`;
export const PlayImgIcon = styled(ImgIcon)`
  padding: 0px 0px 0px 5px;
`;
export const ImgIconOld = styled.img`
  display: block;
  width: 50px;
  height: 50px;
`;

export const ContentWrapper = styled.div`
  width: 90%;
  max-width: 300px;
  margin: 10% auto auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FlashcardText = styled.div`
  margin-top: 20px;
  font-size: 1.2rem;
  text-align: center;
`;
